import React from 'react';
import { BoxTree } from './BoxTree';

export const LeftSidebar: React.FC = () => {
  return (
    <div className="left-sidebar-content">
      <BoxTree />
    </div>
  );
};
